module.exports = __webpack_public_path__ + "static/media/beginning_of_lesson.210a704a.svg";